export class WohnhausanlageModel {
    Id: string;
    Name: string;
    Strasse: string;
    Ort: string;
    Postleitzahl: string;
    HVMitarbeiter : string;
    THVMitarbeiter : string;
    AAVSMitarbeiter : string;
    Eigentuemer : string;
    Objektnr : string;
}


// WEBPACK FOOTER //
// ./src/app/schemas/WohnhausanlageModel.ts